import Alpine from 'alpinejs';
import money from 'alpinejs-money';
import focus from '@alpinejs/focus'
import { register } from 'swiper/element/bundle';
register();
import Cookies from "js-cookie";
import ShyListener from './modules/ShyListener.js';
import { slideDown, slideToggle, slideUp, slideToggleDefaults } from './snippets/slide-toggle-container.js';
import { createFocusTrap } from 'focus-trap';
import $money from './modules/alpine-money.js';
import FruitAnimation from './modules/FruitAnimation.js';

window.Alpine = Alpine;
Alpine.plugin(focus);

// Hack: This next line hides alpine money.
window.Shopify.locale = 'en-US';
Alpine.plugin(money);
$money();

window.Cookies = Cookies;

window.setSectionTabindex = (el, to = "-1") => {
  [...(el instanceof NodeList
    ? el
    : el.querySelectorAll('a, input, button'))
    ].forEach((item) => {
    item.setAttribute("tabindex", to);
  });
};
// window.setSectionTabindexes = (items, to = "-1") => {
//   items.filter(i => ['a','input','button'].indexOf(String(i.nodeName).toLowerCase()) != -1).forEach((item) => {
//     item.setAttribute("tabindex", to);
//   });
// };

window.slideToggle = (el, opts = {}) => {
  slideToggle(el, { ...slideToggleDefaults, ...opts });
};
window.slideUp = (el, opts = {}) => {
  slideUp(el, { ...slideToggleDefaults, ...opts });
};;
window.slideDown = (el, opts = {}) => {
  slideDown(el, { ...slideToggleDefaults, ...opts });
};
window.createFocusTrap = (el, opts = {}) => createFocusTrap(el, opts);

Alpine.store('cartOpen', false);
Alpine.store('mobileMenuOpen', false);

document.addEventListener("DOMContentLoaded", () => {
  // window.shyListener = new ShyListener();
  new FruitAnimation({
    section: document
  });
});

// NOTE: Alpine.start() runs at end of page, in case new components.
